import React, { useState } from 'react'
import {useHistory } from 'react-router-dom';
import { useRef } from "react";
import {
    FormContainer,PageLinkText,AuthBgContainer,FlexContainer,PageLinkTextNoLink, PageTitleText
} from './sign_in.style';
import {
    AppInputField,InputFieldTitleText,AppInputFieldBtn
} from '../../../widget/styledComponents/input_field.style'

import { gql, useMutation } from '@apollo/client';
import AppLogo from '../../../widget/app_logo';
import { toaster } from 'evergreen-ui';


export const AUTH_LOGIN = gql`
mutation FacilityManager_login_sendCode($email: String!, $password: String!) {
  facilityManager_login_sendCode(email: $email, password: $password) {
    code
    success
    error
    token
  }
}
`;

function SignInWidget() {
const history = useHistory()
const [addTodo, { loading }] = useMutation(AUTH_LOGIN);

const handleSubmit=(e)=>{
    e.preventDefault()
    // console.log("clckccy")
    addTodo({
      variables: { 
        email: emailRef.current.value,
        password: passwordRef.current.value,
        
      },
    })
    .then((response) => {
      const data = {token: response.data['facilityManager_login_sendCode']['token'] };
      toaster.notify("Enter the verification code")
      history.push(`/verifySignIn/${data.token}`);
    })
    .catch((error) => {
      toaster.danger(error.message)
    });
  }

const emailRef = useRef(null);
const passwordRef = useRef(null);


const [showPass,setShowPass] = useState(false)

  return (
    <div className='row'>
        <AuthBgContainer className="col s12 m6 l6 hide-on-med-and-down"></AuthBgContainer>
        <div className='col s12 m6 l6 '>
            <div className='mt-100'></div>
            <form onSubmit={handleSubmit}>
            <FormContainer >
               
                <div className='right'>
                    <AppLogo/>
                </div>
                <br/><br/>
                <PageTitleText>
                    <small>Login</small>
                </PageTitleText>
                <br/>
                <InputFieldTitleText>
                    Email Address
                </InputFieldTitleText>
                <AppInputField
                    type="email" 
                    placholder="alijames@gmail.com"
                    ref={emailRef}
                /> 
                <InputFieldTitleText>
                    Password
                </InputFieldTitleText>
                <AppInputField
                    type= {showPass?'text':'password' }
                    ref={passwordRef}
                /> 
                <div className='col s12 right'>
                    <PageLinkTextNoLink className='right' style={{
                    color:"var(--black, #4F46E5) !important",fontSize:"12px",
                    }} onClick={()=>setShowPass(!showPass)}>{showPass?'Hide':'Show'}</PageLinkTextNoLink >
                </div>
                
               
                <AppInputFieldBtn className="mt-50"
                      type='submit'
                      disabled={loading} 
                  >
                    {!loading && 'Login' } 
                    {loading && 'Loading' } 
                </AppInputFieldBtn>
                
                <FlexContainer>
                    Don’t have an account? <PageLinkText className='right' style={{
                        color:"var(--black, #4F46E5) !important",fontSize:"18px",
                        paddingLeft:"10px"
                    }} to="/signup">Sign Up</PageLinkText>
                </FlexContainer>
                <div className='row'>
                <div className='col s12 mt-50 center'>
                    <PageLinkText to="/forgetPassword" style={{
                        color:"var(--black, #4F46E5) !important",fontSize:"18px",
                        paddingLeft:"10px"
                    }} className='center'>ForgetPassword</PageLinkText>
                </div>
                </div>
                

            </FormContainer>
            </form>

        </div>
    </div>
  )
}

export default SignInWidget